import { useState } from "react";
import { useLang } from "../context/LanguageContext";
import { FadeUp, InviewMaskLine, RevealImage } from "../components/Reveal";
import InquiryForm from "../components/InquiryForm";
import { TurnkeySection } from "../components/HomeSections";

const IMG = "/images/private.webp";

export default function PrivateClients() {
  const { t } = useLang();
  const [turnkeyPrefill, setTurnkeyPrefill] = useState("");

  const scrollToForm = () => {
    const el = document.getElementById("private-form-section");
    if (!el) return;
    setTurnkeyPrefill(t("nx.turnkey.prefill"));
    if (window.__lenis) window.__lenis.scrollTo(el, { offset: -60 });
    else el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="bg-[#050607]" data-testid="private-clients-page">
      <section className="px-5 md:px-10 pt-40 pb-20 md:pt-48 md:pb-28 border-b border-white/10">
        <FadeUp><div className="eyebrow mb-8">{t("private.eyebrow")}</div></FadeUp>
        <h1 className="font-display text-[38px] sm:text-[58px] lg:text-[72px] text-[#F3F3F0] max-w-5xl">
          {t("private.title").split("\n").map((l, i) => <InviewMaskLine key={i} delay={0.2 + i * 0.14} className={i === 1 ? "text-[#999995]" : ""}>{l}</InviewMaskLine>)}
        </h1>
        <FadeUp delay={0.35}><p className="mt-8 max-w-xl text-[15px] md:text-[17px] leading-relaxed text-[#999995]">{t("private.body")}</p></FadeUp>
      </section>

      {/* 01 — HOW IT WORKS (single consolidated process section) */}
      <section className="px-5 md:px-10 py-20 md:py-28 grid grid-cols-1 lg:grid-cols-[1fr_2fr] gap-14 border-b border-white/10" data-testid="how-it-works">
        <div className="self-start order-2 lg:order-1">
          <RevealImage src={IMG} alt="Premium vehicle at night — private client sourcing" className="aspect-[4/5] w-full max-w-[480px]" />
          <div className="mono text-[10px] tracking-[0.24em] text-[#666663] mt-3 uppercase">{t("private.imgCaption")}</div>
        </div>
        <div className="order-1 lg:order-2">
          <FadeUp><div className="eyebrow mb-8">01 — {t("nx.how.eyebrow")}</div></FadeUp>
          <div className="border-t border-white/10">
            {t("nx.how.steps").map((s, i) => (
              <FadeUp key={s.t} delay={i * 0.06} className="border-b border-white/10 py-7" data-testid={`how-step-${i + 1}`}>
                <div className="flex items-start gap-6">
                  <div className="mono text-[11px] text-[#555654] pt-1">{String(i + 1).padStart(2, "0")}</div>
                  <div>
                    <h3 className="mono text-[12px] tracking-[0.2em] text-[#F3F3F0] mb-2">{s.t}</h3>
                    <p className="text-[13px] leading-relaxed text-[#8A8A86]">{s.d}</p>
                  </div>
                </div>
              </FadeUp>
            ))}
          </div>
        </div>
      </section>

      {/* 02 — TURNKEY SERVICE (destination-aware) */}
      <TurnkeySection compact number="02" ctaMode="scroll" onCta={scrollToForm} />

      <section id="private-form-section" className="px-5 md:px-10 py-20 md:py-28" data-testid="private-form-section">
        <FadeUp><div className="eyebrow mb-4">{t("forms.inquiry")}</div></FadeUp>
        <FadeUp delay={0.08}><h2 className="font-display text-[30px] sm:text-[42px] text-[#F3F3F0] mb-5">{t("private.formTitle")}</h2></FadeUp>
        <FadeUp delay={0.12}><p className="text-[14px] text-[#999995] max-w-xl mb-12">{t("forms.invite")}</p></FadeUp>
        <div className="max-w-4xl">
          <InquiryForm path="private" prefillMessage={turnkeyPrefill} />
        </div>
      </section>
    </div>
  );
}
